<div class="wrap">
  <ng-container *ngFor="let a of applications">

    <mat-card appearance="outlined" *ngIf="appAuthorized(a)" [ngSwitch]="a?.iconType" [routerLink]="[a.url]" routerLinkActive="router-link-active"
      [ngClass]="{card_active: appAuthorized(a), card_deactive: !appAuthorized(a)}">

      <div class="header">
        <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
        <fa-icon *ngSwitchCase="'faIcon'" [icon]="getIcon(a?.iconName)"></fa-icon>
      </div>

      <mat-card-content>
        <h3>{{a.appName}}</h3>
        <p>
          {{a.description}}
        </p>
      </mat-card-content>

    </mat-card>
  </ng-container>
</div>
